import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import "../../../board/components/details/sidebar/sidebar.scss";
import {
  getExceededPercentage,
  getProgressPercentage,
} from "./progressBarUtils";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  width: 180,
  height: 8,
  marginRight: 10,
  borderRadius: 4,
  "& .MuiLinearProgress-bar": {
    borderRadius: 4,
  },
  "& .MuiLinearProgress-barColorPrimary": {
    backgroundColor: "green",
  },
  "& .MuiLinearProgress-barColorSecondary": {
    backgroundColor: "red",
  },
}));
export default React.memo(function CustomizedProgressBars({
  allocatedHours,
  hoursSpent,
  showOnCardOnBoard,
 listView = false,
 }) {
  const percentage = getProgressPercentage(allocatedHours, hoursSpent);
  const percentageExeed = getExceededPercentage(allocatedHours, hoursSpent);

  return (
    <>
      {showOnCardOnBoard && (
        <Box
          display="flex"
          justifyContent="space-between"
          marginRight="5px"
          marginTop="5px"
          alignItems="center">
          <p className="complete-percent ">
            {hoursSpent}/{allocatedHours || 0}
          </p>
          <p className="complete-percent">{percentage}% completed</p>
        </Box>
      )}
      <div
        className={`${
          percentageExeed ? "custom-progress-bg-above" : "custom-progress-bg"
        }`}>
        <Box display="flex" alignItems="center">
          <BorderLinearProgress
            variant="determinate"
            className="border-linear-progress"
            value={100}
            color={"primary"}
            style={{
              marginRight: "2px",
              width:
                percentage > 100 ? `${percentageExeed}%` : `${percentage}%`,
            }}
          />
        </Box>
      </div>
      {!showOnCardOnBoard && (
        <Box
          display="flex"
          justifyContent="space-between"
          marginRight="10px"
          marginTop="5px"
          alignItems="center">
          <p
            className={
              listView ? "both-hours listView-fontColor" : "both-hours"
            }>
            {hoursSpent}/{allocatedHours || 0}
          </p>
          <p className="complete-percent">{percentage}%</p>
        </Box>
      )}
    </>
  );
})
